import script from "./MyBirthdayView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBirthdayView.vue?vue&type=script&setup=true&lang=js"

import "./MyBirthdayView.vue?vue&type=style&index=0&id=1fbb28e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbb28e6"]])

export default __exports__